import { ADD_MARKET_PRODUCTS, SET_MARKETS_SELECTED_TAB } from 'actionTypes/markets';
import createAction from 'helpers/createAction';

export const addMarketProducts = createAction(ADD_MARKET_PRODUCTS);

const setMarketsSelectedTab = createAction<string>(SET_MARKETS_SELECTED_TAB);

export { setMarketsSelectedTab };
